<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_6 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<v-sheet
			rounded
			color="primary"
			class="my-5 px-4 mt-10 text-h6"
		>
				<span class="tertiary--text">
					Dati Contratto di Servizio
				</span>
		</v-sheet>
		
		<template v-if="pratica.contratto_di_servizio_id === null">
			Contratto di Servizio non ancora caricato
		</template>
		
		<template v-else>
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('ragione_sociale')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.ragione_sociale"
							@input="pratica.contratto_di_servizio.ragione_sociale = $event !== '' ? $event : null"
							label="Ragione Sociale"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
						></v-text-field>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('indirizzo_fatturazione')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.indirizzo_fatturazione"
							@input="pratica.contratto_di_servizio.indirizzo_fatturazione = $event !== '' ? $event : null"
							label="Indirizzo di Fatturazione"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('partita_iva')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.partita_iva"
							@input="pratica.contratto_di_servizio.partita_iva = $event !== '' ? $event : null"
							label="P.IVA (o, in assenza, codice fiscale)"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
						></v-text-field>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('nome')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.nome"
							@input="pratica.contratto_di_servizio.nome = $event !== '' ? $event : null"
							label="Nome"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('cognome')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.cognome"
							@input="pratica.contratto_di_servizio.cognome = $event !== '' ? $event : null"
							label="Cognome"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
						></v-text-field>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('telefono')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.telefono"
							@input="pratica.contratto_di_servizio.telefono = $event !== '' ? $event : null"
							label="Telefono"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('email')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.email"
							@input="pratica.contratto_di_servizio.email = $event !== '' ? $event : null"
							label="Email"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
						></v-text-field>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('pec')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.pec"
							@input="pratica.contratto_di_servizio.pec = $event !== '' ? $event : null"
							label="PEC"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('codice_univoco')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.codice_univoco"
							@input="pratica.contratto_di_servizio.codice_univoco = $event !== '' ? $event : null"
							label="Codice Univoco"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
						></v-text-field>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('data_scadenza_acconto')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-menu
							v-model="menuDataScadenzaAcconto"
							:close-on-content-click="false"
							max-width="290"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									:value="formatDateToItaly(pratica.contratto_di_servizio.data_scadenza_acconto)"
									label="Data di Scadenza dell'Acconto"
									outlined
									dense
									hide-details
									readonly
									:disabled="isLoading"
									:clearable="isAccountManager"
									v-bind="attrs"
									v-on="isAccountManager ? on : null"
									@click:clear="pratica.contratto_di_servizio.data_scadenza_acconto = null"
									:persistent-placeholder="isCliente"
								></v-text-field>
							</template>
							<v-date-picker
								:value="pratica.contratto_di_servizio.data_scadenza_acconto"
								@input="pratica.contratto_di_servizio.data_scadenza_acconto = $event !== '' ? $event : null"
								@change="menuDataScadenzaAcconto = false"
								:readonly="action == 'show' || !isAccountManager"
								first-day-of-week="1"
							></v-date-picker>
						</v-menu>
					</v-badge>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('data_scadenza_saldo')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-menu
							v-model="menuDataScadenzaSaldo"
							:close-on-content-click="false"
							max-width="290"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									:value="formatDateToItaly(pratica.contratto_di_servizio.data_scadenza_saldo)"
									label="Data di Scadenza del Saldo"
									outlined
									dense
									hide-details
									readonly
									:disabled="isLoading"
									:clearable="isAccountManager"
									v-bind="attrs"
									v-on="isAccountManager ? on : null"
									@click:clear="pratica.contratto_di_servizio.data_scadenza_saldo = null"
									:persistent-placeholder="isCliente"
								></v-text-field>
							</template>
							<v-date-picker
								:value="pratica.contratto_di_servizio.data_scadenza_saldo"
								@input="pratica.contratto_di_servizio.data_scadenza_saldo = $event !== '' ? $event : null"
								@change="menuDataScadenzaSaldo = false"
								:readonly="action == 'show' || !isAccountManager"
								first-day-of-week="1"
							></v-date-picker>
						</v-menu>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('importo_acconto')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.importo_acconto"
							@input="pratica.contratto_di_servizio.importo_acconto = $event !== '' ? $event : null"
							label="Importo dell'Acconto"
							outlined
							dense
							hide-details
							readonly
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							type="number"
							min="0"
							:rules="[mixin_rules.min0]"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('importo_saldo')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.importo_saldo"
							@input="pratica.contratto_di_servizio.importo_saldo = $event !== '' ? $event : null"
							label="Importo del Saldo"
							outlined
							dense
							hide-details
							readonly
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							type="number"
							min="0"
							:rules="[mixin_rules.min0]"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<v-sheet
				rounded
				color="primary"
				class="my-5 px-4 mt-10 text-h6"
			>
				<span class="tertiary--text">
					Fatture
				</span>
			</v-sheet>
			
			<v-row>
				<v-col>
					<template v-if="action == 'store' || (action == 'edit' && isAccountManager)">
						<v-badge
							:value="haveFilesBeenModified.fattura_acconto"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-file-input
								v-model="files.fattura_acconto"
								label="Fattura Acconto"
								hide-details
								outlined
								dense
								clearable
								accept=".pdf"
								truncate-length="120"
								@change="setChanged(files.fattura_acconto)"
								@click:clear="pratica.contratto_di_servizio.path_fattura_acconto = null"
								:loading="isLoadingFatturaAcconto"
								:disabled="isLoading"
							>
								<template
									v-slot:append
									v-if="pratica.contratto_di_servizio.path_fattura_acconto !== null && !isLoadingFatturaAcconto"
								>
									<template>
										<v-progress-circular
											v-if="downloadingFatturaAcconto"
											size="24"
											width="3"
											color="primary"
											indeterminate
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="download(pratica.contratto_di_servizio.path_fattura_acconto, 'fattura_acconto')"
										>
											mdi-tray-arrow-down
										</v-icon>
									</template>
								</template>
							</v-file-input>
						</v-badge>
					</template>
					
					<template v-else-if="action == 'show' || isCliente">
						<v-text-field
							:value="getFileNameFromPath(pratica.contratto_di_servizio.path_fattura_acconto)"
							label="Fattura Acconto"
							hide-details
							outlined
							dense
							readonly
						>
							<template
								v-slot:append
								v-if="pratica.contratto_di_servizio.path_fattura_acconto !== null"
							>
								<template>
									<v-progress-circular
										v-if="downloadingFatturaAcconto"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.contratto_di_servizio.path_fattura_acconto, 'fattura_acconto')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
							</template>
						</v-text-field>
					</template>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col>
					<template v-if="action == 'store' || (action == 'edit' && isAccountManager)">
						<v-badge
							:value="haveFilesBeenModified.fattura_saldo"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-file-input
								v-model="files.fattura_saldo"
								label="Fattura Saldo"
								hide-details
								outlined
								dense
								clearable
								accept=".pdf"
								truncate-length="120"
								@change="setChanged(files.fattura_saldo)"
								@click:clear="pratica.contratto_di_servizio.path_fattura_saldo = null"
								:loading="isLoadingFatturaSaldo"
								:disabled="isLoading"
							>
								<template
									v-slot:append
									v-if="pratica.contratto_di_servizio.path_fattura_saldo !== null && !isLoadingFatturaSaldo"
								>
									<template>
										<v-progress-circular
											v-if="downloadingFatturaSaldo"
											size="24"
											width="3"
											color="primary"
											indeterminate
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="download(pratica.contratto_di_servizio.path_fattura_saldo, 'fattura_saldo')"
										>
											mdi-tray-arrow-down
										</v-icon>
									</template>
								</template>
							</v-file-input>
						</v-badge>
					</template>
					
					<template v-else-if="action == 'show' || isCliente">
						<v-text-field
							:value="getFileNameFromPath(pratica.contratto_di_servizio.path_fattura_saldo)"
							label="Fattura Saldo"
							hide-details
							outlined
							dense
							readonly
						>
							<template
								v-slot:append
								v-if="pratica.contratto_di_servizio.path_fattura_saldo !== null"
							>
								<template>
									<v-progress-circular
										v-if="downloadingFatturaSaldo"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.contratto_di_servizio.path_fattura_saldo, 'fattura_saldo')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
							</template>
						</v-text-field>
					</template>
				</v-col>
			</v-row>
		</template>
		
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff', 'contrattoDiServizioDiff', 'haveFilesBeenModified'],
	data() {
		return {
			pratica: {
				id: null,
				id_stato_fase_6: null,
				ci_sono_aggiornamenti_fase_6: false,
				ragione_sociale: null,
				partita_iva: null,
				indirizzo_fatturazione: null,
				data_di_nascita: null,
				luogo_di_nascita: null,
				pec: null,
				codice_univoco: null,
				data_scadenza_acconto: null,
				data_scadenza_saldo: null,
				importo_acconto: null,
				importo_saldo: null,
				contratto_di_servizio: {
					id: null,
					path_fattura_acconto: null,
					path_fattura_saldo: null
				},
			},
			
			menuDataDiNascita: false,
			menuDataScadenzaAcconto: false,
			menuDataScadenzaSaldo: false,
			
			files: {
				fattura_acconto: null,
				fattura_saldo: null
			},
			
			isLoadingFatturaAcconto: false,
			isLoadingFatturaSaldo: false,
			downloadingFatturaAcconto: false,
			downloadingFatturaSaldo: false
		}
	},
	
	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.isSettingPratica = false;
		
		if (this.pratica.ci_sono_aggiornamenti_fase_6  && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_6 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_6',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_6');
		}
		
		if (this.pratica.contratto_di_servizio.path_fattura_acconto !== null && ((this.action != 'show' && this.isAccountManager) || this.isCliente)) {
			this.getFatturaAcconto();
		}
		
		if (this.pratica.contratto_di_servizio.path_fattura_saldo !== null && ((this.action != 'show' && this.isAccountManager) || this.isCliente)) {
			this.getFatturaSaldo();
		}
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente'
		}),
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingFatturaAcconto
				|| this.isLoadingFatturaSaldo;
		}
	},
	
	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica)
				}
			},
			deep: true
		},
		files: {
			handler(newFiles) {
				if (!this.isLoading) {
					this.$emit('update-files', newFiles)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		},
	},
	
	methods: {
		setChanged(file) {
			if (file !== null && !this.isLoading) file.changed = true;
		},
		async getFatturaAcconto() {
			this.isLoadingFatturaAcconto = true;
			this.files.fattura_acconto = await this.getFile(this.pratica.contratto_di_servizio.path_fattura_acconto);
			this.files.fattura_acconto.changed = false;
			this.isLoadingFatturaAcconto = false;
		},
		async getFatturaSaldo() {
			this.isLoadingFatturaSaldo = true;
			this.files.fattura_saldo = await this.getFile(this.pratica.contratto_di_servizio.path_fattura_saldo);
			this.files.fattura_saldo.changed = false;
			this.isLoadingFatturaSaldo = false;
		},
		download(path, key) {
			const fileName = this.getFileNameFromPath(path);
			if (key == 'fattura_acconto') this.downloadingFatturaAcconto = true;
			else if (key == 'fattura_saldo') this.downloadingFatturaSaldo = true;
			axios.post('/api/storage/download',
				{
					path: path
				},
				{
					responseType: 'blob'
				})
				.then(response => {
					saveAs(response.data, fileName);
				})
				.finally(() => {
					if (key == 'fattura_acconto') this.downloadingFatturaAcconto = false;
					else if (key == 'fattura_saldo') this.downloadingFatturaSaldo = false;
				})
		},
	}
	
}
</script>

<style scoped>

</style>